<label class="sr-only" for="locale-select">Locale</label>
<select
  id="locale-select"
  class="rounded-lg border border-gray-300 bg-white px-2 py-1.5 text-sm text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-200"
  [formField]="languageForm.language">
  @for (language of applicationStore.languages(); track language) {
    <option [value]="language">{{ ('app.label.language.' + language) | translate }}</option>
  }
</select>
